import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { object, func, oneOfType, string, number } from 'prop-types'
import { InquiryTypes } from '../../constants/InquiryTypes'
import Modal from 'react-modal'

/**
 * [april 2021]
 * We don't receive the garden surface for the inquiry - so we take it from account
 * Could be great if API gave us this info :)
 */
class InquiryDetailsHeaderComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.toggleOpen = this.toggleOpen.bind(this)
    this.cancelResearch = this.cancelResearch.bind(this)
  }

  toggleOpen () {
    this.setState({isOpen: !this.state.isOpen})
  }

  cancelResearch () {
    this.props.onCloseSearch && this.props.onCloseSearch()
    this.setState({isOpen: !this.state.isOpen})
  }

  get modalContent () {
    const { t } = this.props
    return (
      <div>
        <span onClick={this.toggleOpen} style={{cursor: 'pointer'}} className='ReactModal__close'>
          <img src='/app/images/close.png' alt='' />
        </span>
        <p>{t('common:demande:stop_research')}</p>
        <p>{t('common:demande:stop_research_warning')}</p>
        <p>{t('common:demande:stop_gardeners_proposals')}</p>
        <button onClick={this.cancelResearch} className='btn--default btn--small layout--centered'>
          {t('common:buttons:stop_search')}
        </button>
      </div>
    )
  }
  render () {
    const { t, inquiry, gardenSurface } = this.props
    const { isOpen } = this.state

    return (
      <div className='demandes__section'>
        <p className='demandes__mainlabel'>{t('common:visits:your_project')}</p>
        <div className='demandes__third'>
          <div className='demandes__propertie'>
            <p className='demandes__label'>{t('common:visits:project_type')}</p>
            {
            inquiry.isMaintenance
          ? <p className='demandes__text'>{t('common:visits:maintenance')}</p>
          : <p className='demandes__text'>{t('common:visits:ponctual')}</p>
        }
          </div>
          <div className='demandes__propertie'>
            <p className='demandes__label'>{t('common:visits:project_area')}</p>
            <p className='demandes__text'>{gardenSurface}</p>
          </div>
          <div className='demandes__propertie'>
            <p className='demandes__label'>{t('common:visits:project_visit')}</p>
            {
            inquiry.type === InquiryTypes.REALISATION
            ? <p className='demandes__text'>{t('common:visits:visits_no')}</p>
            : <p className='demandes__text'>{t('common:visits:visits_yes')}</p>
        }
          </div>
        </div>
        <div className='demandes__propertie'>
          <p className='demandes__label'>{t('common:visits:project_description')}</p>
          <p className='demandes__text'>{inquiry.description}</p>
        </div>
        <div className='demandes__propertie'>
          <p className='demandes__label'>{t('common:visits:project_address')}</p>
          {
        inquiry.address &&
        <p className='demandes__text'>{inquiry.address.address} {inquiry.address.zipCode} {inquiry.address.city} </p>
      }
        </div>
        {
        inquiry.searcheable && <div className='demandes__propertie'>
          <button className='btn--green' onClick={this.toggleOpen}>{t('common:buttons:stop_search')}</button>
          <Modal
            isOpen={isOpen}
            onRequestClose={this.toggleOpen}
            contentLabel='Modal to cancel research'
            className='modal modal--auto'
            overlayClassName='signup_overlay' >
            {this.modalContent}
          </Modal>
        </div>
    }
      </div>)
  }
}

InquiryDetailsHeaderComponent.propTypes = {
  t: func,
  inquiry: object,
  gardenSurface: oneOfType([ string, number ]),
  onCloseSearch: func
}

export const InquiryDetailsHeader = translate()(InquiryDetailsHeaderComponent)



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetailsHeader.js